export const Props = () => ({
  id: {
    type: Number,
    required: true
  },
  text: {
    type: String,
    required: true
  },
  color: {
    type: String,
    required: false,
    default: 'default'
  },
  icon: {
    type: String,
    required: false,
    default: null
  }
});